import { render, staticRenderFns } from "./FeeDetails.vue?vue&type=template&id=7cbef83b&scoped=true"
import script from "./FeeDetails.vue?vue&type=script&lang=js"
export * from "./FeeDetails.vue?vue&type=script&lang=js"
import style0 from "./FeeDetails.vue?vue&type=style&index=0&id=7cbef83b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbef83b",
  null
  
)

export default component.exports